import { render, staticRenderFns } from "./anamneseDashboard.vue?vue&type=template&id=62785ee4"
import script from "./anamneseDashboard.vue?vue&type=script&lang=js"
export * from "./anamneseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports